import {DateType, JacksonType} from "@sonner/jackson-service-v2";

@JacksonType("ControleIntegracaoGRPTO")
export class ControleIntegracaoGRPTO {
  id: number;

  @DateType()
  dataProcessamento: Date;

  tipoIntegracao: string;

  documentoContribuinte: string;

  codigoMobiliario: string;

  sucesso: boolean;

  erro: string;

  numeroGuia: string;
}
